import React, { Component } from 'react';

import '../styles/MessagePanel.css';

class MessagePanel extends Component {
  render() {
    // This panel holds two different things in one slot: the board's standing
    // explanations, and a transient note about the move just attempted, which
    // replaces them. The explanations arrive as a list of named entries and the
    // note as a plain string, so the shape is what tells them apart.
    if (!Array.isArray(this.props.message)) {
      return (
        <div className="message-panel">
          {this.props.message}
        </div>
      );
    }

    return (
      <div className="message-panel">
        {this.props.message.map(({ name, text }) =>
          <div className="message-panel-explanation" key={name}>
            <span className="message-panel-name">{name}:</span> {text}
          </div>
        )}
      </div>
    );
  }
}

export default MessagePanel;
